import React from 'react'

import * as S from './styled'

type Props = {
  children: React.ReactNode
  info?: string
}

export const NameCell = ({ children, info }: Props) => (
  <S.Container>
    <S.Name>{children}</S.Name>
    {info && <S.Info>{info}</S.Info>}
  </S.Container>
)
